import { render, staticRenderFns } from "./filtersView.vue?vue&type=template&id=4d0e20e9&scoped=true&lang=pug"
import script from "./filtersView.vue?vue&type=script&lang=js"
export * from "./filtersView.vue?vue&type=script&lang=js"
import style0 from "./filtersView.vue?vue&type=style&index=0&id=4d0e20e9&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d0e20e9",
  null
  
)

export default component.exports